import { RouteConfig } from 'vue-router';
import DownloadSignature from './components/download-signature.vue';

export const downloadSignature: RouteConfig = {
  path: 'downloadsign',
  component: DownloadSignature,
};
